var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellWedding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 3V3.0721C7.8359 3.53281 5.41161 6.14569 5.41161 9.3V12.8394C5.41161 13.6012 5.21344 14.3509 4.83493 15.0212L4.25411 16.0497C3.5016 17.3822 4.51075 19 6.09448 19H17.9055C19.4892 19 20.4984 17.3822 19.7459 16.0497L19.1651 15.0212C18.7866 14.3509 18.5884 13.6012 18.5884 12.8394V9.3C18.5884 6.14569 16.1641 3.53281 13 3.0721V3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3ZM10.7847 14.3695C9.60777 13.4409 8 11.9071 8 10.4568C8 8.03402 10.2001 7.12947 12 9.00105C13.7999 7.12947 16 8.03402 16 10.4568C16 11.9071 14.3922 13.4409 13.2153 14.3695C12.6825 14.7898 12.4161 15 12 15C11.5839 15 11.3175 14.7898 10.7847 14.3695Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87732 20.5C9.61038 21.4145 10.7368 22 12 22C13.2632 22 14.3896 21.4145 15.1227 20.5H8.87732Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellWedding);
export default __webpack_public_path__ + "static/media/bell-wedding.5181fb0ad3799a4c226445600e0eeb60.svg";
export { ForwardRef as ReactComponent };